<template>
  <div class="codeBox">
    <div class="codeMain">
      <img
        class="topBg"
        src="@/assets/img/arkHome/securityCode.png"
        alt="securityCodeBg"
      >
      <div class="botBox">
        <h2>防伪码查询</h2>
        <div class="centerBox">
          <h3>请输入防伪码</h3>
          <div class="from">
            <van-field
              @input="getValue"
              v-model.trim="securityCode"
              type="input"
              clearable
              placeholder="请输入防伪码"
              maxlength="20"
            />
          </div>
          <van-button
            type="primary"
            size="large"
            :disabled='btnState'
            @click="checkCode"
          >查询</van-button>
          <ul>
            <h4>验证提醒</h4>
            <li
              v-for="(item,index) in list"
              :key="index"
            >{{item}}</li>
          </ul>

        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      closeable
    >
      <div class="popupCenter">
        <div v-if="popFlag">
          <h2>正确查询</h2>
          <img
            src="@/assets/img/arkHome/trueIcon.png"
            alt=""
          >
          <span>您所购买的商品为正品。</span>
        </div>
        <div v-else>
          <h2>错误查询</h2>
          <img
            src="@/assets/img/arkHome/errorIcon.png"
            alt=""
          >
          <span>该防伪码不存在，您购买的商品不是正品，或者您输入的防伪码有误。</span>

        </div>

      </div>
    </van-popup>

  </div>

</template>

<script>
import { reqSecurityCode } from '@/api/home';

export default {
  components: {
  },
  data() {
    return {
      securityCode: '', // 防伪码
      btnState: true, // 按钮状态
      list: ['请对照您所购买商品上的防伪标识，刮开涂层，依次输入防伪码验证，结果分为以下两种情况：', '1.正确查询', '您所购买的商品为正品。', '2.错误查询', '该防伪码不存在，您购买的商品不是正品，或者您输入的防伪码有误。'],
      show: false,
      popFlag: true,
    };
  },

  computed: {

  },
  mounted() {
  },

  methods: {
    getValue() {
      if (this.securityCode.length > 1) {
        this.btnState = false;
      } else {
        this.btnState = true;
      }
    },
    async checkCode() {
      const res = await reqSecurityCode(this.securityCode);
      if (res.code === 0) {
        // 成功
        this.show = true;
        this.popFlag = true;
      } else if (res.code === 19105) {
        // 防伪码错误
        this.show = true;
        this.popFlag = false;
      } else {
        this.show = false;
        this.$toast(res.msg);
      }
    },
  },

};

</script>

<style lang="scss" scoped>
.codeBox {
  width: 100%;
  .codeMain {
    position: relative;
    .topBg {
      width: 100%;
      height: 518px;
    }
    .botBox {
      position: absolute;
      top: 16px;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 0 40px;
      h2 {
        font-size: 40px;
        font-weight: 400;
        color: #fff;
        line-height: 56px;
        text-align: center;
      }
      .centerBox {
        box-sizing: border-box;
        padding: 64px 40px;
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 24px;
        margin-top: 80px;
        h3 {
          font-size: 32px;
          font-weight: 500;
          color: #333;
          line-height: 44px;
        }
        .from {
          box-sizing: border-box;
          width: 100%;
          padding: 40px 32px;
          background: #f8f9fb;
          border-radius: 20px;
          margin: 32px 0 64px 0;
          ::v-deep .van-cell {
            background: #f8f9fb;
            padding: 0;
            font-size: 15px;
          }
        }
        ::v-deep .van-button--primary {
          background: #ff7f41;
          border: #ff7f41;
          border-radius: 8px;
        }
        ul {
          h4 {
            font-size: 28px;
            font-weight: 500;
            color: #333;
            line-height: 40px;
            margin: 64px 0 24px 0;
          }
          li {
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 34px;
            &:nth-child(odd) {
              font-weight: 500;
              color: #333333;
              padding: 12px 0 8px 0;
            }
          }
        }
      }
    }
  }
  .popupCenter {
    width: 654px;
    padding-bottom: 64px;
    background: #ffffff;
    text-align: center;
    h2 {
      font-size: 32px;
      font-weight: 500;
      color: #000;
      line-height: 44px;
      padding: 34px 0 64px 0;
    }
    img {
      width: 96px;
      height: 96px;
    }
    span {
      width: 100%;
      box-sizing: border-box;
      padding: 44px 62px 0 62px;
      display: block;
      font-size: 28px;
      font-weight: 400;
      color: #000;
      line-height: 40px;
    }
  }
  ::v-deep .van-popup {
    border-radius: 8px;
  }
  ::v-deep .van-popup__close-icon {
    color: #000 !important;
  }
}
</style>
